import { createSelector } from 'reselect';
const selectOrderState = createSelector((state) => state.order, state => state);
const selectFormToken = createSelector(selectOrderState, state => state.formToken);
const selectPaiementLink = createSelector(selectOrderState, state => state.paiementLink);
const selectOrder = createSelector(selectOrderState, state => state.order);
export { selectFormToken, selectOrder, selectPaiementLink };
